export const validatePassword = (password) => {
	let flag = false
	if (password?.length < 8) flag = true
	if (!/[A-Z]/.test(password)) flag = true
	if (!/[a-z]/.test(password)) flag = true
	if (!/[0-9]/.test(password)) flag = true
	if (!/[^A-Za-z0-9]/.test(password)) flag = true
	if (flag)
		return 'Password must be at least 8 characters and contain at least one uppercase letter, one lowercase letter, one number, and one special character'
	return null
}

export const validateCanadianPhone = (phone) => {
	// Regex: Optional +1 or 1, area code, separator, 3 digits, separator, 4 digits
	if (!phone) return false
	if (phone?.length < 10 || phone?.length > 12) return false
	else if (phone?.length === 10) {
		const regex = /^(\d{3})[\s\-.]?\d{3}[\s\-.]?\d{4}$/
		return regex.test(phone)
	} else {
		const regex = /^(\+?1\s?)?(\(\d{3}\)|\d{3})[\s\-.]?\d{3}[\s\-.]?\d{4}$/
		return regex.test(phone)
	}
}
